import { adminFetch } from "./_client";
import type { MessageTemplate, MessageTemplatePayload } from "./types";

export function fetchMessageTemplates(token: string, opts: { scope?: string; category?: string; locale?: string; includeArchived?: boolean } = {}) {
  const qs = new URLSearchParams();
  if (opts.scope) qs.set("scope", opts.scope);
  if (opts.category) qs.set("category", opts.category);
  if (opts.locale) qs.set("locale", opts.locale);
  if (opts.includeArchived) qs.set("include_archived", "true");
  const suffix = qs.toString() ? `?${qs}` : "";
  return adminFetch<{ templates: MessageTemplate[] }>(`/admin/message-templates${suffix}`, token);
}

export function createMessageTemplate(token: string, payload: MessageTemplatePayload) {
  return adminFetch<{ template: MessageTemplate }>(`/admin/message-templates`, token, {
    method: "POST",
    body: JSON.stringify(payload),
  });
}

export function updateMessageTemplate(token: string, id: number, payload: MessageTemplatePayload) {
  return adminFetch<{ template: MessageTemplate }>(`/admin/message-templates/${id}`, token, {
    method: "PATCH",
    body: JSON.stringify(payload),
  });
}

export function archiveMessageTemplate(token: string, id: number) {
  return adminFetch<{ success: true }>(`/admin/message-templates/${id}`, token, { method: "DELETE" });
}
